<template>
  <div class="whs-slider-fullscreen" v-show="fullscreen" @click.self="toggleFullscreen(false)">
    <div class="whs-slider-fullscreen-content" :class="{ hasSidebar: 'hasSidebar'}">
      <img
        v-show="currentImageUrl"
        class="whs-slider-fullscreen-image"
        :src="currentImageUrl"
        alt="Текущая фотография отеля"
        @click="goToSlide"
      >
      <slot></slot>
    </div>

    <div class="whs-slider-fullscreen-close whs-icon" @click="toggleFullscreen(false)"></div>
    <template v-if="currentImageUrl">
      <div class="whs-slider-fullscreen-left whs-icon" @click="lastSlide"></div>
      <div class="whs-slider-fullscreen-length">{{ currentSlide + 1 }}/{{ images.length }}</div>
      <div class="whs-slider-fullscreen-right whs-icon" @click="nextSlide"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FullscreenGallery',
  props: {
    hasSidebar: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: true
    },
    images: {
      type: Array,
      required: true
    },
    initSlide: {
      type: Number,
      default: 0
    },
    toggleFullscreen: {
      type: Function,
      default: function() {
        return false;
      }
    },
    getImage: Function
  },
  data: function() {
    return {
      currentSlide: this.initSlide
    };
  },
  computed: {
    currentImageUrl: {
      get() {
        return this.getImage(this.currentSlide);
      }
    }
  },
  watch: {
    initSlide: function(slide) {
      this.currentSlide = slide;
    }
  },
  methods: {
    goToSlide(e) {
      e = e || window.event;
      const imageWidth = e.target.width;
      return e.offsetX / imageWidth > 0.3 ? this.nextSlide() : this.lastSlide();
    },
    lastSlide() {
      const slide = this.currentSlide;
      this.currentSlide = slide === 0 ? this.images.length - 1 : slide - 1;
    },
    nextSlide() {
      const slide = this.currentSlide;
      this.currentSlide = slide === this.images.length - 1 ? 0 : slide + 1;
    }
  }
};
</script>

<style scoped>
.whs-slider-fullscreen-close,
.whs-slider-fullscreen-right,
.whs-slider-fullscreen-left {
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg);
  cursor: pointer;
}
.whs-slider-fullscreen-left:before,
.whs-slider-fullscreen-right:before {
  width: 100%;
  text-align: center;
  content: '\f054';
  font-size: 18px;
  color: var(--color-main);
}
.whs-slider-fullscreen-left:before {
  content: '\f053';
}
.whs-slider-fullscreen {
  z-index: 9000;
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: var(--color-text-5);
  align-items: center;
  justify-content: center;
}
.whs-slider-fullscreen-image {
  max-width: 100%;
  object-fit: contain;
  cursor: pointer;
  display: flex;
  flex: 4 4 600px;
  background-color: var(--color-text);
}
.whs-slider-fullscreen-left,
.whs-slider-fullscreen-right,
.whs-slider-fullscreen-length {
  position: absolute;
  left: unset;
  bottom: 12px;
}
.whs-slider-fullscreen-close:before,
.whs-slider-fullscreen-left:before,
.whs-slider-fullscreen-right:before {
  font-size: 18px;
}
.whs-slider-fullscreen-close {
  left: unset;
  top: 24px;
  right: 24px;
}
.whs-slider-fullscreen-close:before {
  width: 100%;
  content: '\f00d';
  text-align: center;
  color: var(--color-main);
}
.whs-slider-fullscreen-length {
  width: 32px;
  bottom: 12px;
  text-align: center;
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-weight: 600;
  color: #fff;
}
.whs-slider-fullscreen-right {
  margin-left: 64px;
}
.whs-slider-fullscreen-left {
  margin-left: -64px;
}
.hasSidebar {
}
.whs-slider-fullscreen-content {
  display: flex;
}
</style>